module.exports = __webpack_public_path__ + "img/ac808038496e472b8af62dba44797584-1024.65f613f6.png";